<template>
  <img 
    src="/src/assets/icons/ru.svg" 
    alt="Russian flag"
    class="w-4 h-4 object-cover rounded-sm"
  />
</template> 